/** Allowed `source` query values for standalone job details (breadcrumb / navigation context). */

export enum JobDetailsPageSource {
  Applications = 'applications',
}

const VALID_SOURCES = new Set<string>(Object.values(JobDetailsPageSource));

export function parseJobDetailsPageSourceFromRouteQuery(raw: unknown): JobDetailsPageSource | null {
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (typeof value !== 'string' || !VALID_SOURCES.has(value)) return null;
  return value as JobDetailsPageSource;
}
